import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import './OrderCard.css';
import { RUPEE } from '../../../../constants/globalConstants';

const OrderCard = ({ item }) => {
  const navigate = useNavigate();

  function formatDate(dateString) {
    return moment(dateString).format('DD MMM YYYY');
  }

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return { color: 'var(--color-green)', bg: 'var(--color-green)' + '20' };
      case 'processing':
        return { color: 'var(--color-lightOrange)', bg: 'var(--color-lightOrange)' + '20' };
      case 'cancelled':
        return { color: 'var(--color-darkRed)', bg: 'var(--color-darkRed)' + '20' };
      default:
        return { color: 'var(--color-secondary)', bg: 'var(--color-secondary)' + '20' };
    }
  };

  const statusStyle = getStatusColor(item?.order_status);

  const handleOrderClick = () => {
    navigate('/order-details', {
      state: {
        orderId: item?._id
      }
    });
  };

  return (
    <div className="order-card" onClick={handleOrderClick}>
      <div className="order-card__row">
        <h3 className="order-card__id">
          Order #{item?._id}
        </h3>
        <span className="order-card__price">
          {RUPEE}{item?.total}
        </span>
      </div>
      <div className="order-card__row">
        <span className="order-card__date">
          {formatDate(item?.order_date)}
        </span>
        <div 
          className="order-card__status"
          style={{ 
            backgroundColor: statusStyle.bg,
            color: statusStyle.color 
          }}
        >
          {item?.order_status}
        </div>
      </div>
    </div>
  );
};

export default OrderCard;